import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { EmitterEvents } from "@/hooks/useEmitter";
import { FrameName } from "../config";
import { UpgradeIds } from "../config/upgrades";
import TileEntity, { type TileEntityWithOnBuildMethod } from "../TileEntity";

type ScoutTowerFrameNames =
	| FrameName.HILLS_SCOUT_TOWER
	| FrameName.MOUNTAINS_SCOUT_TOWER;

class HillsScoutTowerBuildingTileEntity
	extends TileEntity
	implements TileEntityWithOnBuildMethod
{
	public static readonly frameName: ScoutTowerFrameNames =
		FrameName.HILLS_SCOUT_TOWER;

	public get range(): number | null {
		if (!super.range) return null;
		return (
			super.range +
			getUpgradeCurrentReplaceValueById(UpgradeIds.spyglass) +
			getUpgradeCurrentReplaceValueById(UpgradeIds.line_of_sight)
		);
	}

	public onBuild(): void {
		if (!this.range) throw new Error("Range is not defined!");

		this.emitter.emit(EmitterEvents.PhaserRevealRange, {
			x: this.x,
			y: this.y,
			range: this.range,
		});
	}
}

export default HillsScoutTowerBuildingTileEntity;
